import React, { FC } from 'react';
import { useIsMobile } from '@wix/gg-common-lib/hooks';
import { LandingPageStepDesktop } from './components/LandingPageStepDesktop';
import { LandingPageStepMobile } from './components/LandingPageStepMobile';

export const LandingPageStep: FC = () => {
  const isMobile = useIsMobile();

  if (isMobile) {
    return <LandingPageStepMobile />;
  }

  return <LandingPageStepDesktop />;
};
